import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';

import DropdownBox from '../../components/Dropdown/DropdownBox/DropdownBox';
import Option from '../../components/Dropdown/DropdownOption/DropdownOption';
import QA from '../../constants/QATags';
import { dropdownMessages as m } from '../../constants/UserProfile';

export const ThumbUpsDropdownKey = Symbol('ThumbUpsDropdown');

class ThumbUpsDropdown extends React.Component {
  static propTypes = {
    childProps: PropTypes.object.isRequired,
    closeDropdown: PropTypes.func,
    intl: PropTypes.object,
  };

  render() {
    const t = this.props.intl.formatMessage;

    return (
      <DropdownBox menuType={ThumbUpsDropdownKey}>
        <Option
          label={t(m.createStation)}
          key='cs'
          callback={this.props.childProps.onCreateStation}
          closeDropdown={this.props.closeDropdown}
          qaTag={QA.TMCS}
        />
        <Option
          label={t(m.share)}
          callback={this.props.childProps.onShareClick}
          closeDropdown={this.props.closeDropdown}
        />
      </DropdownBox>
    );
  }
}

export const constructors = {
  [ThumbUpsDropdownKey]: injectIntl(ThumbUpsDropdown),
};
